import { z } from "zod";
import {
  ECompanyInformationSection,
  TCompanyInformationSection,
} from "./ECompanyInformationSection";
import { schemes } from "../schema-validation";
import { EProductType } from "../companies/EProductType";

export type TCompanyShareableLinkSectionTitleForEmail =
  | "agreements"
  | "canadian_payroll_onboarding";

export const companyShareableLinkSectionToEmailTitleMap: Record<
  TCompanyInformationSection,
  TCompanyShareableLinkSectionTitleForEmail
> = {
  [ECompanyInformationSection.AGREEMENTS]: "agreements",
  [ECompanyInformationSection.CANADIAN_PAYROLL_ONBOARDING]:
    "canadian_payroll_onboarding",
};

export const companyInformationSectionSchema = z.object({
  name: z.nativeEnum(ECompanyInformationSection),
});

export const companyShareableLinksTokenPayloadSchema = z.object({
  companyID: schemes.companyID(),
  isShareableLink: z.literal(true),
  sections: z.array(companyInformationSectionSchema),
  testMode: z.boolean(),
  whiteLabelID: z.string(),
});

export const companyInformationCompanySchema = z.object({
  company_id: schemes.companyID(),
  business_name: z.string(),
  direct_deposit_form: z.boolean().optional(),
  deposit_account_form: z.boolean().optional(),
  electronic_communication_form: z.boolean().optional(),
  patriot_act_form: z.boolean().optional(),
  product_type: z.nativeEnum(EProductType).optional(),
  puzzl_terms_conditions: z.boolean().optional(),
  reporting_agent_form: z.boolean().optional(),
  tax_information_authorization_form: z.boolean().optional(),
  canadian_payroll_config: z
    .object({
      provider: z.string().optional(),
      company_id: z.string().optional(),
      business_entity_id: z.string().optional(),
      pay_schedule_id: z.string().optional(),
      access_token: z.string().nullable().optional(),
      access_token_expires_at: z.date().nullable().optional(),
    })
    .nullable()
    .optional(),
  business_address: z.string().optional(),
  business_city: z.string().optional(),
  business_state: z.string().optional(),
  business_zip: z.string().optional(),
  business_phone: z.string().optional(),
  email: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
});

export const companyInformationPayloadSchema = z.object({
  company: companyInformationCompanySchema,
  logoURL: z.string().nullish(),
  tokenPayload: companyShareableLinksTokenPayloadSchema,
});

export type TCompanyShareableLinksSection = z.infer<
  typeof companyInformationSectionSchema
>;
export type TCompanyShareableLinksTokenPayload = z.infer<
  typeof companyShareableLinksTokenPayloadSchema
>;
export type TCompanyInformationPayload = z.infer<
  typeof companyInformationPayloadSchema
>;
